// This file is generated by the Webpack next-flight-loader.
const { createProxy } = require("next/dist/build/webpack/loaders/next-flight-loader/module-proxy")

module.exports = createProxy("/app/node_modules/next/dist/client/components/render-from-template-context.js")
